import { ChevronRightSolid, Eye, EyeSlash } from '@icons';
import React, { ReactNode, useState } from 'react';
import { Button } from 'react-bootstrap';
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';

type PanelProps = {
	content: ReactNode;
	title: string;
	defaultVisibility?: boolean;
};

type PanelButtonProps = {
	text: string;
	onClick: () => void;
};

const SplitPanel = ({
	title,
	subtitle,
	panels,
	mainButton,
	secondaryButton,
}: {
	title: string;
	subtitle: string;
	panels: PanelProps[];
	mainButton: PanelButtonProps;
	secondaryButton: PanelButtonProps;
}) => {
	const [panelsVisibility, setPanelsVisibility] = useState(panels.map((panel) => panel.defaultVisibility ?? true));

	const switchVisibilityByIndex = (index: number) => {
		setPanelsVisibility((currentVis) => [...currentVis.slice(0, index), !currentVis[index], ...currentVis.slice(index + 1)]);
	};

	const visiblePanels = panels.filter((_, panelIndex) => panelsVisibility[panelIndex]);

	return (
		<div
			style={{
				width: '100%',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'space-between',
				gap: '32px',
				backgroundColor: '#eef1f2',
			}}
		>
			<div style={{ width: '100%' }}>
				<h1 style={{ fontSize: '28px', fontWeight: 700, margin: 0 }}>{title}</h1>
				<h2 style={{ fontSize: '18px', fontWeight: 700, margin: 0, color: '#4A5968' }}>{subtitle}</h2>
			</div>
			<div style={{ width: '100%' }}>
				<div
					style={{
						width: '100%',
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
						justifyContent: 'center',
						gap: '32px',
						padding: '24px',
						backgroundColor: '#DEE4F1',
						borderRadius: '8px 8px 0 0',
					}}
				>
					{panels.map((panel, panelIndex) => (
						<Button
							variant={panelsVisibility[panelIndex] ? 'secondary' : 'light'}
							style={{
								width: '200px',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								gap: '12px',
							}}
							onClick={() => switchVisibilityByIndex(panelIndex)}
						>
							{panel.title}

							{panelsVisibility[panelIndex] ? (
								<Eye style={{ width: '24px', height: '24px', margin: 0 }} />
							) : (
								<EyeSlash style={{ width: '24px', height: '24px', margin: 0 }} />
							)}
						</Button>
					))}
				</div>
				<div style={{ width: '100%', backgroundColor: 'white', borderRadius: '0 0 8px 8px' }}>
					<PanelGroup direction="horizontal">
						{visiblePanels.map((panel, panelIndex) => (
							<>
								<Panel style={{ padding: '16px 24px' }}>{panel.content}</Panel>
								{panelIndex < visiblePanels.length - 1 && (
									<PanelResizeHandle style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
										<div
											style={{
												position: 'absolute',
												top: 0,
												left: '50%',
												height: '100%',
												borderWidth: '1px',
												borderStyle: 'solid',
												borderColor: '#2A3A64',
											}}
										/>
										<div
											style={{
												backgroundColor: '#2A3A64',
												color: 'white',
												height: '24px',
												borderRadius: '16px',
												display: 'flex',
												alignItems: 'center',
											}}
										>
											<ChevronRightSolid style={{ width: '24px', height: '24px', transform: 'scale(-1, 1)' }} />
											<ChevronRightSolid style={{ width: '24px', height: '24px' }} />
										</div>
									</PanelResizeHandle>
								)}
							</>
						))}
					</PanelGroup>
				</div>
			</div>
			<div
				style={{
					width: '100%',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'flex-end',
					gap: '16px',
				}}
			>
				<Button
					variant="light"
					style={{
						width: '285px',
						height: '48px',
					}}
					onClick={secondaryButton.onClick}
				>
					{secondaryButton.text}
				</Button>

				<Button
					variant="secondary"
					style={{
						width: '285px',
						height: '48px',
					}}
					onClick={mainButton.onClick}
				>
					{mainButton.text}
				</Button>
			</div>
		</div>
	);
};

export default SplitPanel;
